import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faFacebook, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { restaurantInfo } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [website, setWebsite] = useState(''); // Honeypot field
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [subscriptionMessage, setSubscriptionMessage] = useState('');
  const [formLoadTime, setFormLoadTime] = useState(Date.now());

  // Track form load time for anti-spam
  useEffect(() => {
    setFormLoadTime(Date.now());
  }, []);

  // Función para manejar clicks sin interferencias
  const handleDirectClick = (e, url) => {
    // No prevenir el evento - dejar que el navegador maneje el link normalmente
    console.log(`Navegando a: ${url}`);
  };

  // Función para manejar la suscripción
  const handleSubscription = async (e) => {
    e.preventDefault();
    
    // Clear previous messages
    setSubscriptionMessage('');
    
    if (!email) {
      setSubscriptionMessage('Por favor ingresa tu email');
      return;
    }

    if (!email.includes('@')) {
      setSubscriptionMessage('Por favor ingresa un email válido');
      return;
    }

    // Calculate time to fill
    const timeToFill = Date.now() - formLoadTime;

    setIsSubscribing(true);
    
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      
      const response = await fetch(`${backendUrl}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          website: website,  // Honeypot field
          time_to_fill: timeToFill,
          source: 'Footer'  // Identificar origen
        }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSubscriptionMessage(data.message || '¡Gracias por suscribirte! Te mantendremos informado.');
        setEmail('');
        setWebsite('');
        setFormLoadTime(Date.now());
        
        // Clear success message after 5 seconds
        setTimeout(() => {
          setSubscriptionMessage('');
        }, 5000);
      } else {
        setSubscriptionMessage(data.detail || 'Error al suscribirte. Por favor, intenta nuevamente.');
      }
      
    } catch (error) {
      console.error('Error subscribing:', error);
      setSubscriptionMessage('Error de conexión. Por favor, intenta nuevamente.');
    } finally {
      setIsSubscribing(false);
    }
  };

  return (
    <footer className="bg-black text-white">
      {/* Main footer content */}
      <div className="container-custom py-10 md:py-16 px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-12">
          
          {/* Brand Section */}
          <div className="md:col-span-2 pl-0 md:pl-4 flex flex-col items-center md:items-start text-center md:text-left">
            <img 
              src="/assets/logos/logo-blanco.png" 
              alt="ADASTRA" 
              className="h-32 md:h-48 mb-4 md:mb-6"
            />
            <p className="text-gray-300 text-sm md:text-lg mb-6 md:mb-8 max-w-md leading-relaxed px-4 md:px-0">
              Experiencia gastronómica única en el corazón de La Habana Vieja. 
              Donde cada momento se convierte en un recuerdo inolvidable.
            </p>
            <div className="flex space-x-6 justify-center md:justify-start" style={{ zIndex: 1000 }}>
              <a 
                href="https://instagram.com/adastrarestaurant"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-300 transition-all duration-300 hover:scale-125 cursor-pointer inline-block p-2"
                aria-label="Instagram"
                style={{ 
                  zIndex: 1001, 
                  position: 'relative', 
                  display: 'inline-block',
                  pointerEvents: 'auto',
                  minWidth: '48px',
                  minHeight: '48px'
                }}
              >
                <FontAwesomeIcon 
                  icon={faInstagram} 
                  className="text-3xl" 
                  style={{ pointerEvents: 'none' }}
                />
              </a>
              <a 
                href="https://facebook.com/people/Adastra-Restaurante/61568078246941"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-300 transition-all duration-300 hover:scale-125 cursor-pointer inline-block p-2"
                aria-label="Facebook"
                style={{ 
                  zIndex: 1001, 
                  position: 'relative', 
                  display: 'inline-block',
                  pointerEvents: 'auto',
                  minWidth: '48px',
                  minHeight: '48px'
                }}
              >
                <FontAwesomeIcon 
                  icon={faFacebook} 
                  className="text-3xl" 
                  style={{ pointerEvents: 'none' }}
                />
              </a>
              <a 
                href="https://tiktok.com/@adastra_restaurant"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-300 transition-all duration-300 hover:scale-125 cursor-pointer inline-block p-2"
                aria-label="TikTok"
                style={{ 
                  zIndex: 1001, 
                  position: 'relative', 
                  display: 'inline-block',
                  pointerEvents: 'auto',
                  minWidth: '48px',
                  minHeight: '48px'
                }}
              >
                <FontAwesomeIcon 
                  icon={faTiktok} 
                  className="text-3xl" 
                  style={{ pointerEvents: 'none' }}
                />
              </a>
              <a 
                href="https://youtube.com/@adastrarestaurant"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-300 transition-all duration-300 hover:scale-125 cursor-pointer inline-block p-2"
                aria-label="YouTube"
                style={{ 
                  zIndex: 1001, 
                  position: 'relative', 
                  display: 'inline-block',
                  pointerEvents: 'auto',
                  minWidth: '48px',
                  minHeight: '48px'
                }}
              >
                <FontAwesomeIcon 
                  icon={faYoutube} 
                  className="text-3xl" 
                  style={{ pointerEvents: 'none' }}
                />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg md:text-xl font-semibold mb-4 md:mb-6">Enlaces</h3>
            <div className="grid grid-cols-2 md:grid-cols-1 gap-x-4 gap-y-2.5 md:gap-y-4">
              <Link to="/menu" className="block text-gray-300 hover:text-white transition-colors text-sm md:text-lg">
                Menú
              </Link>
              <Link to="/reservas" className="block text-gray-300 hover:text-white transition-colors text-sm md:text-lg">
                Reservas
              </Link>
              <Link to="/experiencias" className="block text-gray-300 hover:text-white transition-colors text-sm md:text-lg">
                Experiencias
              </Link>
              <Link to="/gift-cards" className="block text-gray-300 hover:text-white transition-colors text-sm md:text-lg">
                Gift Cards
              </Link>
              <Link to="/nosotros" className="block text-gray-300 hover:text-white transition-colors text-sm md:text-lg">
                Nosotros
              </Link>
              <Link to="/galeria" className="block text-gray-300 hover:text-white transition-colors text-sm md:text-lg">
                Galería
              </Link>
              <Link to="/contacto" className="block text-gray-300 hover:text-white transition-colors text-sm md:text-lg">
                Contacto
              </Link>
              <Link to="/resenas" className="block text-gray-300 hover:text-white transition-colors text-sm md:text-lg">
                Reseñas
              </Link>
              <Link to="/blog" className="block text-gray-300 hover:text-white transition-colors text-sm md:text-lg">
                Blog
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg md:text-xl font-semibold mb-4 md:mb-6">Contacto</h3>
            <div className="space-y-2.5 md:space-y-4">
              <a 
                href={`tel:${restaurantInfo.phone}`}
                className="flex items-center text-gray-300 hover:text-white transition-colors group"
              >
                <FontAwesomeIcon icon={faPhone} className="mr-3 text-base md:text-lg group-hover:scale-110 transition-transform" />
                <span className="text-sm md:text-lg">{restaurantInfo.phone}</span>
              </a>
              <p className="text-gray-300 text-sm md:text-lg">
                {restaurantInfo.address}
              </p>
              <p className="text-gray-400 text-xs md:text-base">
                Todos los días: 12:00 PM - 12:00 AM
              </p>
            </div>
          </div>

          {/* Newsletter Subscription */}
          <div>
            <h3 className="text-lg md:text-xl font-semibold mb-4 md:mb-6">Newsletter</h3>
            <p className="text-gray-300 text-xs md:text-sm mb-4 md:mb-6 leading-relaxed">
              Suscríbete para recibir noticias sobre eventos especiales, menús estacionales y promociones exclusivas.
            </p>
            
            <form onSubmit={handleSubscription} className="space-y-4">
              <div className="relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Tu email"
                  className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:border-white focus:ring-1 focus:ring-white transition-colors"
                  disabled={isSubscribing}
                />
              </div>
              
              {/* Honeypot field - hidden from users, only bots will fill it */}
              <div style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden' }}>
                <label htmlFor="website-footer">Website (do not fill)</label>
                <input
                  type="text"
                  id="website-footer"
                  name="website"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                  tabIndex="-1"
                  autoComplete="off"
                  aria-hidden="true"
                />
              </div>
              
              <button
                type="submit"
                disabled={isSubscribing}
                className="w-full bg-white text-black font-semibold py-3 px-6 rounded-lg hover:bg-gray-200 transition-colors flex items-center justify-center space-x-2 disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {isSubscribing ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-2 border-black border-t-transparent"></div>
                    <span>Suscribiendo...</span>
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faPaperPlane} />
                    <span>SUSCRIBIRME</span>
                  </>
                )}
              </button>
            </form>
            
            {subscriptionMessage && (
              <p className={`mt-4 text-sm ${subscriptionMessage.includes('Gracias') ? 'text-green-400' : 'text-red-400'}`}>
                {subscriptionMessage}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 py-6 md:py-8">
        <div className="container-custom px-4 md:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0 pl-2 md:pl-4">
            <p className="text-gray-400 text-xs md:text-lg text-center md:text-left">
              © {currentYear} {restaurantInfo.name}. Todos los derechos reservados. By <a href="https://forms.gle/WMscPXuuft2utPD87" target="_blank" rel="noopener noreferrer" className="font-bold underline hover:text-green-400 transition-colors">Adastra Labs</a>
            </p>
            <div className="flex space-x-4 md:space-x-8 text-xs md:text-lg">
              <Link to="/privacidad" className="text-gray-400 hover:text-white transition-colors">
                Privacidad
              </Link>
              <Link to="/terminos" className="text-gray-400 hover:text-white transition-colors">
                Términos
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;